module.exports = __webpack_public_path__ + "static/media/breaker.d1e8da00.png";